import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './components/failed/failed.component';

export const appRoutes: Route[] = [
  {
    path: 'dashboard',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./components/dashboard/dashboard.component').then(
        (c) => c.DashboardComponent
      ),
  },
  {
    path: 'login-failed',
    component: FailedComponent,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'tenants-list',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./components/tenants/list.component').then(
        (c) => c.TenantsListComponent
      ),
  },
  {
    path: 'tenants-form',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./components/tenants/form.component').then(
        (c) => c.TenantFormComponent
      ),
  },
  {
    path: 'policies',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./modules/policies/policies.module').then(
        (mod) => mod.PoliciesModule
      ),
  },
  {
    path: 'categories',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('./modules/categories/categories.module').then(
        (mod) => mod.CategoriesModule
      ),
  },
  {
    path: 'netblocks',
    loadChildren: () =>
      import('./modules/netblocks/netblocks.module').then(
        (mod) => mod.NetblocksModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'domains',
    loadChildren: () =>
      import('./modules/domains/domains.module').then(
        (mod) => mod.DomainsModule
      ),
    canActivate: [MsalGuard],
  },
];
